import React from "react";

export default function MyButton({
  children,
  variant = "primary",
  size = "md",
  icon: Icon,
  onClick,
  className = "",
  type = "submit",
  disabled = false,
}) {
  const baseStyles =
    "inline-flex min-w-36 items-center uppercase justify-center font-medium rounded-lg focus:outline-none transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed";

  const variantStyles = {
    primary: "bg-blue-600 text-white hover:bg-blue-700",
    secondary: "bg-gray-600 text-white hover:bg-gray-700",
    danger: "bg-red-600 text-white hover:bg-red-700",
    success: "bg-green-600 text-white hover:bg-green-700",
    outline:
      "border border-gray-400/50 bg-slate-200 text-gray-600 hover:bg-gray-300",
  };

  const sizeStyles = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-6 py-3 text-lg",
  };

  return (
    <button
      onClick={onClick}
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
      disabled={disabled}
      type={type}
    >
      {Icon && <Icon className="w-5 h-5 mr-2" />}
      {children}
    </button>
  );
}
